"use client";

interface Dashboard {
    id: string;
    name: string;
    description: string;
    url: string;
    category: string;
    icon: string;
}

const dashboards: Dashboard[] = [
    {
        id: "dashboard1",
        name: "Bienenstock Monitor",
        description:
            "Live-Überblick: Temperatur, Luftfeuchte und Wetterdaten aus dem Bienenstock – direkt aus Heilbronn.",
        url: "https://beehive-grafana-production.up.railway.app/d/beehappy-monitor/beehappy-e28094-bienenstock-monitor?",
        category: "Monitoring Dashboard",
        icon: "📊",
    },
    {
        id: "dashboard2",
        name: "Dashboard 2",
        description:
            "KI-gestützte Analysen: Intelligente Auswertung der Sensordaten für neue Einblicke ins Bienenleben.",
        url: "https://claude.ai/public/artifacts/15a5890b-44ab-4ce5-b7b2-2a556be65c1a",
        category: "AI Dashboard",
        icon: "📈",
    },
];

export default function DashboardPreview() {
    const handleDashboardClick = (url: string) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="space-y-3 flex flex-col justify-center h-full">
            {dashboards.map((dashboard) => (
                <div
                    key={dashboard.id}
                    onClick={() => handleDashboardClick(dashboard.url)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            handleDashboardClick(dashboard.url);
                        }
                    }}
                    className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer border border-gray-200 hover:border-yellow-400 p-4 group"
                >
                    <div className="flex items-start gap-3">
                        <div className="text-xl flex-shrink-0">{dashboard.icon}</div>

                        <div className="flex-1 min-w-0">
                            <div className="flex items-center justify-between mb-1">
                                <h4 className="text-sm font-semibold text-gray-800 group-hover:text-yellow-600 transition-colors truncate">
                                    {dashboard.name}
                                </h4>
                                <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full flex-shrink-0 ml-2">
                                    {dashboard.category}
                                </span>
                            </div>

                            <p className="text-xs text-gray-600 line-clamp-2 mb-2">{dashboard.description}</p>

                            <div className="flex items-center text-xs text-yellow-600 font-medium">
                                <span>Dashboard öffnen</span>
                                <svg
                                    className="ml-1 w-3 h-3 group-hover:translate-x-0.5 transition-transform"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
